// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 2360) return "static/chunks/2360.3325d3c3adb8fd42.js";
	if (chunkId === 6985) return "static/chunks/6985.b75c82140fa4ba50.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-" + {"3260":"7a0b2d416729bb78","6757":"bb0381b146b377d0","8853":"002bc11c6b14a246"}[chunkId] + ".js";
};